import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/user/bo_view_ico.png'
import _imports_1 from '@/assets/user/bo_good_ico.png'
import _imports_2 from '@/assets/user/bo_bad_ico.png'
import _imports_3 from '@/assets/user/bo_comment_ico.png'
import _imports_4 from '@/assets/user/good_ico.png'
import _imports_5 from '@/assets/user/good_ico_on.png'
import _imports_6 from '@/assets/user/bad_ico.png'
import _imports_7 from '@/assets/user/bad_ico_on.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, " 커뮤니티 ", -1)
const _hoisted_5 = { class: "bo_view" }
const _hoisted_6 = { class: "bo_view_tit" }
const _hoisted_7 = { class: "tit" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "info" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_15 = { class: "board_info" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "bo_gb_btns" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "off"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "on"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "off",
  alt: ""
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "on",
  alt: ""
}, null, -1)
const _hoisted_26 = { class: "board_btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("p", {
                  innerHTML: $setup.contentDecode($setup.content.title)
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString($setup.content.date), 1),
              ($setup.content.meIdx === $setup.state.userInfo.idx)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "bo_info_btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.showModifyBtn && $setup.showModifyBtn(...args)))
                  }, _hoisted_13))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "bo_modify_box",
                style: _normalizeStyle($setup.state.isBtnShow ? 'display:block' : 'display:none')
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "modify_btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.modifyContent($setup.content.idx)))
                }, "수정"),
                _hoisted_14,
                _createElementVNode("button", {
                  type: "button",
                  class: "modify_btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.deleteBtn()))
                }, "삭제")
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, [
                _hoisted_16,
                _createElementVNode("b", null, _toDisplayString($setup.numberFormat($setup.content.cntRead)), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_17,
                _createElementVNode("b", null, _toDisplayString($setup.content.cntLike), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_18,
                _createElementVNode("b", null, _toDisplayString($setup.content.cntBad), 1)
              ]),
              _createElementVNode("span", null, [
                _hoisted_19,
                _createElementVNode("b", null, _toDisplayString($setup.content.cntComment), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "bo_view_content",
              innerHTML: $setup.contentDecode($setup.content.content)
            }, null, 8, _hoisted_20),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["good_btn", $setup.state.isLike === true ? 'active' : '']),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.pushLike && $setup.pushLike(...args)))
              }, [
                _hoisted_22,
                _hoisted_23,
                _createElementVNode("span", null, "좋아요 [" + _toDisplayString($setup.content.cntLike) + "]", 1)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["bad_btn", $setup.state.isBad === true ? 'active' : '']),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.pushBad && $setup.pushBad(...args)))
              }, [
                _hoisted_24,
                _hoisted_25,
                _createElementVNode("span", null, "싫어요 [" + _toDisplayString($setup.content.cntBad) + "]", 1)
              ], 2)
            ]),
            _createVNode(_component_Comment, {
              contentIdx: $setup.content.idx,
              cntComment: $setup.content.cntComment
            }, null, 8, ["contentIdx", "cntComment"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_router_link, {
              to: "#",
              onClick: $setup.backToList
            }, {
              default: _withCtx(() => [
                _createTextVNode("목록")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}